const INITIAL_STATE = {
  outboundVolumeList: [],
  productSelected: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_OUTBOUND_VOLUME_LIST': {
      return { ...state, outboundVolumeList: action.outboundVolumeList };
    }
    case 'SET_USER_REMOVAL_LIST': {
      return { ...state, userRemovalList: action.userRemovalList };
    }
    case 'SET_OUTBOUND_RANGE_PRODUCT_SELECTED': {
      return { ...state, productSelected: action.productSelected };
    }
    default:
      return state;
  }
};
